module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("In writing these stories over a period of years, I often asked a friend to read one or more – and comment. I am grateful for the time they took. But so many encouraged me to seek publication that I have yielded to temptation. The editorial staff of Austin Macauley, my publishers, has provided great support and assistance for my previous publications. And I thank them for having maintained the same for this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0